import { Box } from '@mui/material';
import { ReactNode } from 'react';

export interface props {
  children?: ReactNode;
}

export default function BoxDesktop({ children }: props) {
  return (
    <Box
      sx={{
        p: 12,
        minHeight: '53vh',
        marginTop: '-15px',
      }}>
      {children}
    </Box>
  );
}
